var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 1.66602C12.4177 3.94798 13.6023 6.90938 13.6667 9.99935C13.6023 13.0893 12.4177 16.0507 10.3333 18.3327M10.3333 1.66602C8.24893 3.94798 7.06437 6.90938 7 9.99935C7.06437 13.0893 8.24893 16.0507 10.3333 18.3327M10.3333 1.66602C5.73096 1.66602 2 5.39698 2 9.99935C2 14.6017 5.73096 18.3327 10.3333 18.3327M10.3333 1.66602C14.9357 1.66602 18.6667 5.39698 18.6667 9.99935C18.6667 14.6017 14.9357 18.3327 10.3333 18.3327M2.41668 7.49935H18.25M2.41667 12.4993H18.25",
    stroke: "#667085",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe02);
export default __webpack_public_path__ + "2cf1234aa01678ea2b85b88847193b6f.svg";
export { ForwardRef as ReactComponent };